module.exports = __webpack_public_path__ + "static/media/garbage.24ad147d.svg";